package com.shadowings.gero.data.lessons.chapter8

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.data.lessons.buildVsoRecapPhoneticKeyboardQuizzes
import com.shadowings.gero.data.lessons.buildVsoRecapWordSelectionQuizzes
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_recap_vso_alyn_1
import gero.composeapp.generated.resources.exp_content_recap_vso_alyn_2
import gero.composeapp.generated.resources.exp_content_recap_vso_alyn_3
import gero.composeapp.generated.resources.exp_content_recap_vso_nilo_1
import gero.composeapp.generated.resources.exp_content_recap_vso_nilo_2
import gero.composeapp.generated.resources.exp_content_recap_vso_nilo_3
import gero.composeapp.generated.resources.exp_content_recap_vso_nilo_4
import gero.composeapp.generated.resources.exp_content_recap_vso_nilo_5
import gero.composeapp.generated.resources.exp_title_recap_vso
import kotlin.random.Random

fun getRecapVsoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(word = "O34-G36:D21-A2-Y3-A1", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_nilo_2,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "O34-G36:D21-A2-Y3-A1-V28-N35:N29-X1:W22",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "O34-G36:D21-A2-Y3-A1-V28-N35:N29-X1:W22-N35:N35:N35",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_nilo_3,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "O34-G36:D21-A2-Y3-A1-D60-A1-V28-N35:N29-X1:W22-N35:N35:N35",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_alyn_3,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_nilo_4,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_vso,
            content = Res.string.exp_content_recap_vso_nilo_5,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getRecapVsoQuizContent(
    languageCode: String,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val wordSelection = buildVsoRecapWordSelectionQuizzes(
        random = Random,
        languageCode = languageCode,
        count = 8,
        verbSentences = verbSentences
    )
    val keyboardQuizzes = buildVsoRecapPhoneticKeyboardQuizzes(
        random = Random,
        languageCode = languageCode,
        count = 2,
        verbSentences = verbSentences
    )
    return (wordSelection + keyboardQuizzes).shuffled()
}
